export default __webpack_public_path__ + "static/media/makan_support_management_system.20ce80ab.png";